import { ElectionInputStructure } from './electionInputStructure.interface';
import { AgentInfo } from './agent-info.interface';
import { SaveQuoteMetaData } from '../../producer/saved-quotes/interfaces/save-quote-data.interface';
import { Person } from '../../form-wrappers/form-components/individual-market-persons/interfaces/person.interface';
import { URL_PARAM_REFERRAL_TYPE } from '../components/configs/interfaces/globalStateStructure.interface';
import { Product } from '../../plan-selection/interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../../plan-selection/interfaces/plan-attributes.interface';
import { ENROLLMENT_FLOW } from '../../form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum';
import { APP_STATUS } from '../../producer/enums/app-status.enum';
import { DOCUMENT_UPLOAD_TYPES } from '../components/configs/interfaces/life-event.state-structure.interface';
export interface EnrollmentPersonalInformation {
  county: string;
  countyCode: number;
  state: string;
  zipCode: string;
  firstName: any;
  lastName: any;
  personalPhoneNumber: string;
  facilityPhoneNumber: string;
}

export interface ProductData {
  planId: string;
  planName: string;
  cmsPlanID: string;
  pbpId: string;
  segmentId: string;

  // reconcilation alignment
  monthlyPremium: number;
  planDetails: Product<PlanAttributes, SummaryView>
}

export interface EnrollmentData {
  effectiveDate: any;
  saveElectionAppIn: ElectionInputStructure[];
  productData: ProductData;
  userType: string;
  userId: string;
  submissionChannel: string;
  coverageDate: any;

  applicationType: URL_PARAM_REFERRAL_TYPE;
  enrollmentChannel: ENROLLMENT_CHANNEL;
  enrollmentFlow: ENROLLMENT_FLOW;

  sepInformation?: EnrollmentApplicationSEPData; // Added if SEP workflow; isApplicableCircumstance.toUpperCase() === "YES"
  producerInd?: boolean; // if submitted with producer involvement
  
}

export interface AuthorizedRepresentative {
  firstName?: string;
  middleInitial?: string;
  lastName?: string;
  suffix?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
}

export interface EnrollmentApplicationSEPData {
  fullName: string;
  isAttested: boolean;
  documentcontrolnumber: {
      documentcontrolnumber: string;
      doctype: string;
  }[];
  documentUploadType: DOCUMENT_UPLOAD_TYPES[];
  dateSubmitted: string;
  lifeEvent: {
      categoryId: string;
      date: string;
      eventCd: string;
      eventId: string;
      calculatedEffectiveDate: string;
      requestedEffectiveDate: string;
  }

  editorName?: string // for SEP Review Dashboard Submissions only 
}
export interface EnrollmentApplicationSubscriberPerson extends Person {
  languageReadCode: "5" | string;
  languageWrittenCode: "6" | string;
  languageSpokenCode: "7" | string;
}

export enum ENROLLMENT_CHANNEL {
  AGENT_RETAIL = "Store",
  AGENT_TELESALES = "TeleSales",
  AGENT_GENERIC = "Producer",
  CONSUMER = "Consumer" 
}

/** FULL PAYLOAD */
export interface EnrollPayloadRequest {
  approvalFlow: boolean;
  enrollment: EnrollmentData;
  personalInfo: EnrollmentPersonalInformation;
  submitStatus: APP_STATUS.IN_PROGRESS | APP_STATUS.SUBMITTED;
  ubk: string;
  ddValue: string;
  firstName: string;
  lastName: string;
  productType: string;
  productDescription: string;
  authRep: AuthorizedRepresentative;
  agentInfo: AgentInfo;
  applicationTrackingId?: string; // Tends to be attached at submission time

  // Fields being added during reconciliation of existing payload to request
  market: "Individual" | string;
  applicant: Person[];

  salesforceAccountId: string;
  salesforceOpportunityId: string;

  referralid?: string; // for quote hand offs
  customerId?: string;
  opportunityId?: string;
}

export interface EnrollPayloadSaveRequest extends EnrollPayloadRequest {
  submitStatus: APP_STATUS.IN_PROGRESS;
  saveQuoteData: SaveQuoteMetaData;
}

export interface EnrollPayloadSubmitRequest extends EnrollPayloadRequest {
  submitStatus: APP_STATUS.IN_PROGRESS | APP_STATUS.SUBMITTED;
}
